import * as C from "../constants";

import { get_token, get_current_user, post_reset_user_pass_req } from "../utils/http";
import { parseJSON } from "../utils/misc";

import { history} from "../history";

import { initializePush } from "../utils/pushNotifications"

export function loginUserRequest() {
    return {
        type: C.LOGIN_USER_REQUEST,
    };
}

export function loginUserSuccess(token, username, role, name="Без имени", isMasterOrganization=false) {
    localStorage.setItem("token", token);
    return {
        type: C.LOGIN_USER_SUCCESS,
        payload: {
            token: token,
            username: username,
            role: role,
            name: name,
            isMasterOrganization: isMasterOrganization,
        }
    };
}

export function loginUserFailure(error) {
    return {
        type: C.LOGIN_USER_FAILURE,
        payload: {
            status: error.response.status,
            statusText: error.response.statusText,
        },
    };
}

export function resetUserPassRequest() {
    return {
        type: C.RESET_PASSWORD_REQUEST,
    }
}

export function resetuserPassFailure(statusCode, statusText) {
    return {
        type: C.RESET_PASSWORD_FAILURE,
        payload: {
            status: statusCode,
            statusText: statusText,
        }
    }
}

export function resetUserPasswordSucces() {
    return {
        type: C.RESET_PASSWORD_SUCCESS,
    }
}

export function logout() {
    localStorage.removeItem("token");
    return {
        type: C.LOGOUT_USER,
    };
}

export function logoutAndRedirect() {
    return (dispatch) => {
        dispatch(logout());
        history.push("/login");
    }
}

export function redirectToRoute(route) {
    return () => {
        history.push(route);
    };
}

export function loginUser(username, password, rememberMe, redirectTo) {
    return function (dispatch) {
        dispatch(loginUserRequest());
        return get_token(username, password, rememberMe)
            .then(parseJSON)
            .then(response => {
                try {
                    get_current_user(response.token)
                        .then(parseJSON)
                        .then(r => {
                            try {
                                dispatch(loginUserSuccess(response.token, r.username, r.role, r.name));
                                initializePush(response.token);
                                history.push(redirectTo || "/");
                            } catch (e) {
                                dispatch(loginUserFailure({
                                    response: {
                                        status: 403,
                                        statusText: "Ошибка получения информации пользователя.",
                                    },
                                }));
                            }
                        })
                } catch (e) {
                    dispatch(loginUserFailure({
                        response: {
                            status: 403,
                            statusText: "Неверный токен",
                        },
                    }));
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    dispatch(loginUserFailure({
                        response: {
                            status: 401,
                            statusText: "Неверное имя пользователя или пароль.",
                        },
                    }));
                } else {
                    dispatch(loginUserFailure({
                        response: {
                            status: 503,
                            statusText: "Ошибка доступа к серверу"
                        }
                    }))
                }
            });
    };
}

export function resetUserPass(email) {
    return function (dispatch) {
        dispatch(resetUserPassRequest());
        return post_reset_user_pass_req(email)
            .then(() => {
                dispatch(resetUserPasswordSucces());
                history.push("/login");
            })
            .catch(() => {dispatch(resetuserPassFailure(
                403, "Неверный email"
            ))})
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js